import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createThemeLookupService from '../services/createThemeLookupService';
import ThemeLookupForm from './ThemeLookupForm';

const EMPTY_THEME_LOOKUP = { title: '' };

const NewThemeLookup = ({ open, dispatchCreateThemeLookupPost, createThemeLookupFetch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body => dispatchCreateThemeLookupPost(body, () => navigate('/theme-lookups'), t),
    [dispatchCreateThemeLookupPost, navigate, t]
  );

  if (!open) return null;

  return (
    <ThemeLookupForm
      header={t('newThemeLookup')}
      onSubmit={handleSubmit}
      submitProcessing={createThemeLookupFetch.pending}
      returnRoute="/theme-lookups"
      cancelRoute="/theme-lookups"
      data={EMPTY_THEME_LOOKUP}
    />
  );
};

NewThemeLookup.propTypes = {
  dispatchCreateThemeLookupPost: PropTypes.func.isRequired,
  createThemeLookupFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewThemeLookup.defaultProps = { open: false };

export default createThemeLookupService(NewThemeLookup);
